module.exports = "/_next/static/images/HeroPhone-405f14f9e407c5f7244c928beaa66bc9.png";